export class CheckBoxListControlValueItem {

    protected id: string;
    protected value: string;

    constructor(raw?: { id: string, value: string }) {

        if (raw) {
            this.id = raw.id;
            this.value = raw.value;
        }
    }

    getId(): string {
        return this.id;
    }

    getValue(): string {
        return this.value;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/check-box-list/form/check-box-list-control-value-item.model.ts